import { resetButtonStylingCSS } from '@tmh-website/styles/global';
import StyledTypo from '@tmh-website/styles/typo';
import { formElementThemes } from '@tmh-website/ui/FormElements';
import { DayContentProps } from 'react-day-picker';
import styled, { css } from 'styled-components';
import { CalendarThemeColor } from './Calendar.theme';

interface ContainerProps {
  $activeModifiers: DayContentProps['activeModifiers'];
  $themeColor: CalendarThemeColor;
}

const disabledCss = css<ContainerProps>`
  color: ${props => props.theme.color[formElementThemes[props.$themeColor].text]};
  cursor: not-allowed;
  opacity: 0.4;
`;

const outsideCss = css<ContainerProps>`
  color: ${props => props.theme.color[formElementThemes[props.$themeColor].text]};
  opacity: 0.4;
`;

const todayCss = css<ContainerProps>`
  color: ${props => props.theme.color[formElementThemes[props.$themeColor].text]};
  background-color: ${props => props.theme.color[formElementThemes[props.$themeColor].surface.normal]};
`;

const selectedCss = css<ContainerProps>`
  color: ${props => props.theme.color[formElementThemes[props.$themeColor].checked.text]};
  pointer-events: none;
  background-color: ${props => props.theme.color[formElementThemes[props.$themeColor].checked.normal]} !important;
`;

export const Container = styled.button<ContainerProps>`
  ${resetButtonStylingCSS};
  ${StyledTypo.uiTextCss};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  line-height: 1;
  border-radius: ${props => props.theme.borderRadius.small};
  transition: ease 0.125s;
  ${props => {
    if (props.$activeModifiers.disabled) {
      return disabledCss;
    } else if (props.$activeModifiers.selected) {
      return selectedCss;
    } else if (props.$activeModifiers.today) {
      return todayCss;
    } else if (props.$activeModifiers.outside) {
      return outsideCss;
    }
    return;
  }}

  ${props =>
    !props.$activeModifiers.disabled &&
    css`
      &:hover {
        background-color: ${props.theme.color[formElementThemes[props.$themeColor].surface.normal]};
      }
    `}
`;
